import Vue from 'vue'
import Component from 'vue-class-component'
import UserHeader from '../shared/UserHeader.vue'
import authStore from '@/store/auth/auth-store'
import StatementReferences from '@/components/statement/StatementReferences.vue';
import StatementTags from '@/components/statement/StatementTags.vue';
import StatementReact from '@/components/statement/StatementReact.vue';
import StatementRemove from '@/components/statement/StatementRemove.vue';
import StatementConvoRemove from '@/components/statement/StatementConvoRemove.vue';
import StatementAdd from '@/components/statement/StatementAdd.vue';
import StatementConvoAdd from '@/components/statement/StatementConvoAdd.vue';
import { IStatement } from '@/model/statement';
import StatementCommentAdd from '@/components/statement/StatementCommentAdd';
import StatementCommentRemove from '@/components/statement/StatementCommentRemove';
import StatementNonauth from '@/components/statement/StatementNonauth';
import feedStore from '@/store/feed/feed-store';

@Component({
  name: 'statementView',
  props: ['statement', 'convo', 'buttonType'],
  components: {
    'user-header': UserHeader,
    'statement-references': StatementReferences,
    'statement-tags': StatementTags,
    'statement-react': StatementReact,
    'statement-nonauth': StatementNonauth,
    'statement-add': StatementAdd,
    'statement-convo-add': StatementConvoAdd,
    'statement-comment-add': StatementCommentAdd,
    'statement-remove': StatementRemove,
    'statement-convo-remove': StatementConvoRemove,
    'statement-comment-remove': StatementCommentRemove,
  },
})
export default class StatementView extends Vue {
  get isEditable () {
    const statement = this.getStatement();
    console.log('StatementView: statement.meta: %j', statement.meta)
    console.log('StatementView: authStore.user: %j', authStore.user)
    return authStore.user && statement && statement.meta && statement.meta.creator.id === authStore.user.id
  }

  getStatement (): IStatement {
    return this.$props['statement'] as IStatement
  }
}
